import type { SelectProps } from '@mantine/core'
import { Select } from '@mantine/core'
import React from 'react'

import type { EDocType } from '@flecto/types'

import useSelectCountries from './hooks/useCountries'

type SelectCountry = EDocType | string | number
interface SelectCountryProps
  extends Omit<SelectProps, 'data' | 'value' | 'defaultValue'> {
  value?: SelectCountry
  defaultValue?: SelectCountry
}

export const SelectCountry = (props: SelectCountryProps) => {
  const { countries } = useSelectCountries()

  return (
    <Select
      {...props}
      data={countries}
      data-testid='select-country'
      value={props.value ? String(props.value).toUpperCase() : undefined}
      searchable
      defaultValue={
        props.defaultValue
          ? String(props.defaultValue).toUpperCase()
          : undefined
      }
    />
  )
}
